export default "__VITE_ASSET__4efb826f__"